import { type TemplateResult, html, nothing } from 'lit';
import { ButtonConfig } from '../components/tm-footer.types';

export interface TmFooterConfig {
    direction: 'row' | 'column';
    wrap: boolean;
    justifyCenter: boolean;
    buttonConfig: ButtonConfig[];
    slotContent: TemplateResult | (() => TemplateResult);
    visible: boolean;
}

export const defaultConfig: TmFooterConfig = {
    direction: 'column',
    wrap: false,
    justifyCenter: true,
    buttonConfig: [],
    slotContent: html`${nothing}`,
    visible: true,
};

Object.freeze(defaultConfig);
